// Sample/Dummy Data Generator for Template Mode
// Based on real scan data structure from actual Pipsqueak scans
// This provides realistic-looking sample data that matches the backend structure exactly

export const generateSampleScanData = () => {
    return {
        // Pipsqueak metadata
        Pisqueak: {
            version: "1.2.3",
            date: "2026/01/15"
        },

        // Internet Speed Test
        "Internet Speed": {
            target: "8.8.8.8",
            latency_ms: 15,
            packet_loss_percent: 0,
            success: true,
            Download: 250.5,
            Upload: 150.3
        },

        // Active Directory Scan - COMPREHENSIVE
        "Ad Scan": {
            timestamp: "2026-01-15 04:00:00",
            domain_controllers: [
                {
                    name: "DC-01",
                    dns_name: "DC-01.sample.local",
                    os: "Windows Server 2019 Datacenter",
                    os_version: "10.0 (17763)",
                    when_created: "2020-01-15T10:00:00+00:00",
                    last_logon: "2026-01-14",
                    password_last_set: "2026-01-10",
                    service_principal_names: [
                        "DNS/DC-01.sample.local",
                        "HOST/DC-01.sample.local",
                        "ldap/DC-01.sample.local"
                    ],
                    account_flags: ["SERVER_TRUST_ACCOUNT", "TRUSTED_FOR_DELEGATION"],
                    is_disabled: false,
                    risk_flags: []
                }
            ],
            inactive_accounts: [
                {
                    username: "olduser",
                    display_name: "Old User Account",
                    user_principal_name: "olduser@sample.com",
                    account_flags: ["NORMAL_ACCOUNT"],
                    is_disabled: false,
                    password_never_expires: false,
                    password_last_set: "2023-06-15",
                    last_logon: "2023-08-20",
                    bad_password_count: 0,
                    bad_password_time: "1601-01-01T00:00:00+00:00",
                    lockout_time: "1601-01-01T00:00:00+00:00",
                    account_created: "2020-01-01T10:00:00+00:00",
                    account_expires: "9999-12-31T23:59:59.999999+00:00",
                    is_admin: false,
                    member_of: [],
                    ou: "SAMPLE USERS",
                    risk_flags: ["Password Stale", "Inactive > 30 Days"]
                },
                {
                    username: "testuser",
                    display_name: "Test User",
                    user_principal_name: "testuser@sample.com",
                    account_flags: ["NORMAL_ACCOUNT"],
                    is_disabled: false,
                    password_never_expires: true,
                    password_last_set: "2022-01-01",
                    last_logon: "2023-12-01",
                    bad_password_count: 0,
                    bad_password_time: "1601-01-01T00:00:00+00:00",
                    lockout_time: "1601-01-01T00:00:00+00:00",
                    account_created: "2019-01-01T10:00:00+00:00",
                    account_expires: "9999-12-31T23:59:59.999999+00:00",
                    is_admin: false,
                    member_of: [],
                    ou: "SAMPLE USERS",
                    risk_flags: ["Password Never Expires", "Inactive > 30 Days"]
                }
            ],
            "AD Users": [
                {
                    username: "Administrator",
                    display_name: "Administrator",
                    user_principal_name: "admin@sample.com",
                    account_flags: ["NORMAL_ACCOUNT"],
                    is_disabled: false,
                    password_never_expires: false,
                    password_last_set: "2026-01-10",
                    last_logon: "2026-01-14",
                    bad_password_count: 0,
                    bad_password_time: "1601-01-01T00:00:00+00:00",
                    lockout_time: "1601-01-01T00:00:00+00:00",
                    account_created: "2020-01-01T00:00:00+00:00",
                    account_expires: "1601-01-01T00:00:00+00:00",
                    is_admin: true,
                    member_of: [
                        "CN=Administrators,CN=Builtin,DC=sample,DC=local",
                        "CN=Domain Admins,CN=Users,DC=sample,DC=local"
                    ],
                    ou: "Users",
                    risk_flags: ["Admin Account"]
                },
                {
                    username: "jdoe",
                    display_name: "John Doe",
                    user_principal_name: "jdoe@sample.com",
                    account_flags: ["NORMAL_ACCOUNT"],
                    is_disabled: false,
                    password_never_expires: false,
                    password_last_set: "2026-01-05",
                    last_logon: "2026-01-14",
                    bad_password_count: 0,
                    bad_password_time: "1601-01-01T00:00:00+00:00",
                    lockout_time: "",
                    account_created: "2021-03-15T10:00:00+00:00",
                    account_expires: "9999-12-31T23:59:59.999999+00:00",
                    is_admin: false,
                    member_of: [],
                    ou: "SAMPLE USERS",
                    risk_flags: []
                },
                {
                    username: "jsmith",
                    display_name: "Jane Smith",
                    user_principal_name: "jsmith@sample.com",
                    account_flags: ["NORMAL_ACCOUNT"],
                    is_disabled: false,
                    password_never_expires: true,
                    password_last_set: "2024-06-01",
                    last_logon: "2026-01-13",
                    bad_password_count: 0,
                    bad_password_time: "1601-01-01T00:00:00+00:00",
                    lockout_time: "",
                    account_created: "2020-06-01T10:00:00+00:00",
                    account_expires: "9999-12-31T23:59:59.999999+00:00",
                    is_admin: false,
                    member_of: [],
                    ou: "SAMPLE USERS",
                    risk_flags: ["Password Never Expires"]
                }
            ],
            Computers: [
                {
                    name: "DESKTOP-01",
                    host: "DESKTOP-01.sample.local",
                    os: "Windows 10 Pro",
                    os_version: "10.0 (19045)",
                    last_logon: "2026-01-14",
                    pwd_last_set: "2026-01-10",
                    created: "2021-05-10T10:00:00+00:00",
                    account_flags: ["WORKSTATION_TRUST_ACCOUNT"],
                    is_disabled: false,
                    service_principal_names: [
                        "TERMSRV/DESKTOP-01",
                        "HOST/DESKTOP-01.sample.local"
                    ],
                    ou_or_container: "Computers",
                    risk_flags: []
                },
                {
                    name: "LAPTOP-02",
                    host: "LAPTOP-02.sample.local",
                    os: "Windows 11 Enterprise",
                    os_version: "10.0 (22000)",
                    last_logon: "2023-06-01",
                    pwd_last_set: "2023-05-01",
                    created: "2020-01-01T10:00:00+00:00",
                    account_flags: ["WORKSTATION_TRUST_ACCOUNT"],
                    is_disabled: false,
                    service_principal_names: [
                        "HOST/LAPTOP-02.sample.local"
                    ],
                    ou_or_container: "Computers",
                    risk_flags: ["Inactive > 30 Days"]
                }
            ],
            groups: [
                {
                    name: "Domain Admins",
                    description: "Designated administrators of the domain",
                    member_count: 2,
                    group_type: "Security",
                    when_created: "2020-01-01T00:00:00+00:00"
                },
                {
                    name: "IT Department",
                    description: "IT staff members",
                    member_count: 5,
                    group_type: "Security",
                    when_created: "2020-06-01T00:00:00+00:00"
                }
            ],
            gpo_policies: [
                {
                    name: "Default Domain Policy",
                    guid: "{31B2F340-016D-11D2-945F-00C04FB984F9}",
                    when_created: "2020-01-01T00:00:00+00:00",
                    when_changed: "2025-12-01T00:00:00+00:00"
                }
            ],
            OU_list: [
                {
                    no: 1,
                    ou: "SAMPLE USERS",
                    distinguished_name: "OU=SAMPLE USERS,DC=sample,DC=local",
                    members: ["jsmith", "jdoe", "testuser"]
                },
                {
                    no: 2,
                    ou: "SAMPLE COMPUTERS",
                    distinguished_name: "OU=SAMPLE COMPUTERS,DC=sample,DC=local",
                    members: ["DESKTOP-01", "LAPTOP-02"]
                }
            ]
        },

        // Network Devices - COMPREHENSIVE WITH ALL NEEDED DATA
        network_devices: [
            {
                ip: "192.168.1.100",
                hostname: "DESKTOP-SAMPLE01",
                status: "Up",
                open_ports: {
                    "80": "HTTP",
                    "443": "HTTPS",
                    "3389": "RDP"
                },
                device_type: "Desktop",
                firmware_version: "unknown",
                email_hosting: {
                    IP: "192.168.1.100",
                    PTR_Record: "",
                    ASN_Description: "Unknown",
                    Network_Name: "Unknown",
                    Hosting: "Unknown or custom provider"
                },
                dns_audit: {
                    ip: "192.168.1.100",
                    hostname: "",
                    domain: null,
                    records: {},
                    audit: ["No PTR record found - cannot perform DNS audit."]
                },
                system: {
                    "WMI Error": null,
                    "Hardware Informations": {
                        "CPU Available": 65,
                        "RAM Available (GB)": 8,
                        cpu: "Intel Core i7-9700K",
                        ram: "16 GB",
                        disk_total: "500 GB",
                        disk_used: "320 GB",
                        disk_free: "180 GB"
                    },
                    Firewall: {
                        Domain: true,
                        Private: true,
                        Public: false
                    },
                    "Operating System": "Windows 10 Pro",
                    os_version: "Windows 10 Pro",
                    "Local Users": [
                        { username: "admin", "Password Expires": false },
                        { username: "user1", "Password Expires": true }
                    ],
                    Administrators: [
                        { username: "admin", "Password Expires": false }
                    ],
                    regular_admins: ["admin"],
                    Services: [
                        { name: "Windows Update", start_mode: "Automatic", status: "Running", account: "LocalSystem" },
                        { name: "Custom Service", start_mode: "Manual", status: "Stopped", account: "LocalSystem" }
                    ],
                    Antivirus: {
                        installed: true,
                        name: "Windows Defender",
                        status: "Up to date",
                        last_update: "2026-01-14"
                    },
                    Encryption: {
                        enabled: false,
                        type: "None"
                    },
                    backups: {
                        last_backup: "2026-01-10T02:00:00Z",
                        status: "Warning",
                        notes: "Backup failed - disk full"
                    }
                },
                source: "wmi_and_network"
            },
            {
                ip: "192.168.1.101",
                hostname: "LAPTOP-SAMPLE02",
                status: "Up",
                open_ports: {
                    "22": "SSH",
                    "445": "SMB"
                },
                device_type: "Laptop",
                firmware_version: "unknown",
                email_hosting: {
                    IP: "192.168.1.101",
                    PTR_Record: "",
                    ASN_Description: "Unknown",
                    Network_Name: "Unknown",
                    Hosting: "Unknown or custom provider"
                },
                dns_audit: {
                    ip: "192.168.1.101",
                    hostname: "",
                    domain: null,
                    records: {},
                    audit: ["No PTR record found - cannot perform DNS audit."]
                },
                system: {
                    "WMI Error": null,
                    "Hardware Informations": {
                        "CPU Available": 75,
                        "RAM Available (GB)": 12,
                        cpu: "Intel Core i5-10400",
                        ram: "16 GB",
                        disk_total: "1 TB",
                        disk_used: "450 GB",
                        disk_free: "550 GB"
                    },
                    Firewall: {
                        Domain: true,
                        Private: true,
                        Public: true
                    },
                    "Operating System": "Windows 11 Enterprise",
                    os_version: "Windows 11 Enterprise",
                    "Local Users": [
                        { username: "admin", "Password Expires": true },
                        { username: "user2", "Password Expires": true }
                    ],
                    Administrators: [
                        { username: "admin", "Password Expires": true }
                    ],
                    regular_admins: [],
                    Services: [
                        { name: "Windows Update", start_mode: "Automatic", status: "Running", account: "LocalSystem" },
                        { name: "SSH Server", start_mode: "Automatic", status: "Running", account: "LocalSystem" }
                    ],
                    Antivirus: {
                        installed: true,
                        name: "Windows Defender",
                        status: "Up to date",
                        last_update: "2026-01-14"
                    },
                    Encryption: {
                        enabled: true,
                        type: "BitLocker"
                    },
                    backups: {
                        last_backup: "2026-01-14T03:00:00Z",
                        status: "Success",
                        notes: "Backup completed."
                    }
                },
                source: "wmi_and_network"
            },
            {
                ip: "192.168.1.50",
                hostname: "SERVER-SAMPLE03",
                status: "Up",
                open_ports: {
                    "80": "HTTP",
                    "443": "HTTPS",
                    "3306": "MySQL",
                    "5432": "PostgreSQL"
                },
                device_type: "Server",
                firmware_version: "unknown",
                email_hosting: {
                    IP: "192.168.1.50",
                    PTR_Record: "",
                    ASN_Description: "Unknown",
                    Network_Name: "Unknown",
                    Hosting: "Unknown or custom provider"
                },
                dns_audit: {
                    ip: "192.168.1.50",
                    hostname: "",
                    domain: null,
                    records: {},
                    audit: ["No PTR record found - cannot perform DNS audit."]
                },
                system: {
                    "WMI Error": null,
                    "Hardware Informations": {
                        "CPU Available": 85,
                        "RAM Available (GB)": 24,
                        cpu: "Intel Xeon E5-2680",
                        ram: "64 GB",
                        disk_total: "2 TB",
                        disk_used: "800 GB",
                        disk_free: "1.2 TB"
                    },
                    Firewall: {
                        Domain: true,
                        Private: true,
                        Public: true
                    },
                    "Operating System": "Windows Server 2019",
                    os_version: "Windows Server 2019",
                    "Local Users": [
                        { username: "administrator", "Password Expires": true },
                        { username: "service_account", "Password Expires": false }
                    ],
                    Administrators: [
                        { username: "administrator", "Password Expires": true }
                    ],
                    regular_admins: [],
                    Services: [
                        { name: "Windows Update", start_mode: "Automatic", status: "Running", account: "LocalSystem" },
                        { name: "MySQL", start_mode: "Automatic", status: "Running", account: "mysql_service" },
                        { name: "PostgreSQL", start_mode: "Automatic", status: "Running", account: "postgres_service" }
                    ],
                    Antivirus: {
                        installed: true,
                        name: "Windows Defender",
                        status: "Up to date",
                        last_update: "2026-01-14"
                    },
                    Encryption: {
                        enabled: true,
                        type: "BitLocker"
                    },
                    backups: {
                        last_backup: "2026-01-14T01:00:00Z",
                        status: "Success",
                        notes: "Backup completed."
                    }
                },
                source: "wmi_and_network"
            }
        ],

        // MS365 Sample Data - COMPREHENSIVE
        MS365: {
            users: [
                { username: "user1@sample.com", display_name: "Sample User 1", mfa_enabled: true, license: "E3", last_login: "2026-01-14T10:00:00Z", is_admin: false },
                { username: "user2@sample.com", display_name: "Sample User 2", mfa_enabled: false, license: "E5", last_login: "2026-01-10T15:30:00Z", is_admin: false },
                { username: "admin@sample.com", display_name: "Admin User", mfa_enabled: true, license: "E5", last_login: "2026-01-14T08:00:00Z", is_admin: true }
            ],
            MFA: [
                { "MFA Enabled": 1 },
                { "MFA Enabled": 0 },
                { "MFA Enabled": 1 }
            ],
            inactive_accounts: [
                { username: "user3@sample.com", display_name: "Inactive User", last_login: "2025-11-20T09:00:00Z" }
            ],
            policies: [
                { name: "Password Policy", status: "Compliant", last_modified: "2025-12-01" },
                { name: "MFA Policy", status: "Non-Compliant", last_modified: "2025-11-15" }
            ]
        },

        // Localhost Sample Data - COMPREHENSIVE
        localhost: {
            "Hardware Informations": {
                "CPU Available": 75,
                "RAM Available (GB)": 8,
                cpu: "Intel Core i7-9700K",
                ram: "16 GB",
                disk_total: "500 GB",
                disk_used: "320 GB",
                disk_free: "180 GB",
                "Local Users": [
                    { username: "admin", "Password Expires": false },
                    { username: "user1", "Password Expires": true }
                ],
                Administrators: [
                    { username: "admin", "Password Expires": false }
                ],
                regular_admins: ["admin"],
                Firewall: {
                    Domain: true,
                    Private: true,
                    Public: false
                },
                OS: "Windows 10 Pro",
                "Installed Applications": [
                    { name: "Microsoft Office", version: "2021", publisher: "Microsoft" },
                    { name: "Google Chrome", version: "120.0", publisher: "Google" }
                ]
            },
            System: {
                Firewall: {
                    Domain: true,
                    Private: true,
                    Public: false
                },
                os_version: "Windows 10 Pro",
                install_date: "2022-03-15T00:00:00Z",
                last_boot: "2026-01-10T08:00:00Z",
                Encryption: {
                    enabled: false,
                    type: "None"
                }

            },
            "External vulnerability": [
                {
                    ip: "203.0.113.1",
                    open_ports: {
                        "80": "HTTP",
                        "443": "HTTPS",
                        "22": "SSH"
                    }
                }
            ],
            Services: [
                { name: "Windows Update", start_mode: "Automatic", status: "Running", account: "LocalSystem" },
                { name: "Custom Service", start_mode: "Manual", status: "Stopped", account: "LocalSystem" }
            ]
        },

        // External Risk Scan Sample Data - FOR TEMPLATE MODE
        external: {
            domain: "sample-domain.com",
            risk_score: 85,
            risk_level: "High",
            risk_score_history: [
                { date: "2025-12-01", score: 80 },
                { date: "2025-12-15", score: 82 },
                { date: "2026-01-01", score: 85 }
            ],
            scan_date: "2026-01-15T12:00:00Z",
            categories: [
                {
                    name: "DNS Security",
                    score: 90,
                    severity: "low",
                    findings: [
                        { title: "SPF Record Found", status: "PASS", severity: "info", description: "SPF record is present and valid.", value: "v=spf1 include:_spf.google.com ~all" },
                        { title: "DMARC Record Missing", status: "FAIL", severity: "high", description: "DMARC record is not found.", value: "No record found" }
                    ]
                },
                {
                    name: "Email Security",
                    score: 75,
                    severity: "medium",
                    findings: [
                        { title: "Open Relay", status: "PASS", severity: "critical", description: "Server is not an open relay.", value: "Closed" },
                        { title: "Blacklist Check", status: "PASS", severity: "high", description: "Domain is not blacklisted.", value: "Clean" }
                    ]
                },
                {
                    name: "SSL/TLS Security",
                    score: 60,
                    severity: "medium",
                    findings: [
                        { title: "Weak Cipher Suites", status: "FAIL", severity: "medium", description: "Server supports weak ciphers.", value: "RC4, 3DES" },
                        { title: "Certificate Valid", status: "PASS", severity: "info", description: "SSL certificate is valid.", value: "Valid until 2027" }
                    ]
                },
                {
                    name: "Security Headers",
                    score: 50,
                    severity: "high",
                    findings: [
                        { title: "HSTS Missing", status: "FAIL", severity: "high", description: "HTTP Strict Transport Security header is missing.", value: "Missing" },
                        { title: "CSP Missing", status: "FAIL", severity: "medium", description: "Content Security Policy header is missing.", value: "Missing" }
                    ]
                },
                {
                    name: "Infrastructure",
                    score: 95,
                    severity: "low",
                    findings: [
                        { title: "Server Info Leaked", status: "PASS", severity: "low", description: "Server header does not leak version info.", value: "Hidden" }
                    ]
                },
                {
                    name: "Breach Intelligence",
                    score: 100,
                    severity: "low",
                    findings: [
                        { title: "Domain Breach Check", status: "PASS", severity: "critical", description: "Domain usage not found in recent breaches.", value: "Clean" }
                    ]
                }
            ],
            compliance: {
                "ISO 27001": { status: "Non-Compliant", score: 65 },
                "NIST": { status: "Partial", score: 70 },
                "GDPR": { status: "Compliant", score: 90 }
            }
        },

        // PII Sample Data - COMPREHENSIVE
        PII: {
            EMAIL_ADDRESS: [
                { value: "sample1@example.com", location: "Document1.docx", line: 15 },
                { value: "sample2@example.com", location: "Spreadsheet.xlsx", line: 42 },
                { value: "test@company.com", location: "Report.pdf", line: 8 }
            ],
            CREDIT_CARD: [
                { value: "****-****-****-1234", location: "Invoice.pdf", line: 25 },
                { value: "****-****-****-5678", location: "Payment.xlsx", line: 12 }
            ],
            PHONE_NUMBER: [
                { value: "(555) 123-4567", location: "Contacts.txt", line: 5 }
            ],
            SSN: [
                { value: "***-**-1234", location: "HR_Records.xlsx", line: 45 }
            ]
        },

        // HIBP Sample Data - COMPREHENSIVE
        HIBP_result: {
            breached_accounts: [
                { email: "sample@example.com", breaches: ["LinkedIn", "Adobe"], breach_count: 2, most_recent: "2023-05-15" },
                { email: "user@company.com", breaches: ["Dropbox"], breach_count: 1, most_recent: "2022-08-20" }
            ]
        },

        // Export Data for charts and summaries
        exportData: {
            "Network Scan": {
                devices: 3,
                desktops: 1,
                laptops: 1,
                servers: 1,
                sensitive_ports: 4,
                other_ports: 6
            },
            "Active Directory Scan": {
                users: 3,
                computers: 2,
                groups: 2,
                inactive_accounts: 2
            },
            "Microsoft 365 Scan": {
                users: 3,
                mfa_enabled: 2,
                mfa_disabled: 1,
                inactive_accounts: 1
            },
            "Localhost Scan": {
                cpu_available: 75,
                ram_available_gb: 8
            },
            "PII Scan": {
                EMAIL_ADDRESS: 3,
                CREDIT_CARD: 2,
                PHONE_NUMBER: 1,
                SSN: 1
            }
        },

        // Findings Summary - Backend format: [category, status, compliance%, notes, cost]
        findings: [
            ["Backups", "Warning", 67, "1 device without recent backups", 50],
            ["Firewall", "Healthy", 100, "All devices have firewall enabled", 0],
            ["Antivirus", "Healthy", 100, "All devices have up-to-date antivirus", 0],
            ["MFA", "Warning", 67, "1 user without MFA enabled", 50],
            ["Admins", "Warning", 50, "1 admin with non-expiring password", 100],
            ["Accounts", "Warning", 67, "2 inactive accounts detected", 100],
            ["Encryption", "Warning", 67, "1 device without encryption", 50],
            ["Services", "Attention", 100, "Non-default services detected", 50],
            ["Open Ports", "Attention", 100, "Sensitive ports detected", 120],
            ["PII", "Attention", 100, "7 PII instances detected", 700],
            ["Dark Web", "Warning", 100, "2 breached accounts found", 200],
            ["OS", "Healthy", 100, "All OS versions supported", 0]
        ]
    };
};

// Helper to check if we should use sample data
export const shouldUseSampleData = (builderMode, scanData) => {
    // Use sample data if in template mode OR if no scan data available
    return builderMode === 'template' || !scanData || Object.keys(scanData).length === 0;
};
